import {
    Button,
    Checkbox,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    ListItemText,
    MenuItem,
    TextField,
    Typography
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {CloseRounded} from "@mui/icons-material";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {useStatusValuesProduct} from "../../../component/useStatusValuesProduct";
import {useProductCodeActions} from "../../../service/useProductCodeActions";
import {
    PROMO_TYPOLOGY_CREDIT_CARD,
    PROMO_TYPOLOGY_SHORT_TERM,
    PROMO_TYPOLOGY_SUBSCRIPTION
} from "../../../component/Constants";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        },
    },
};

interface AddProductModalProps {
    open: boolean,
    handleClose: Function,
    categories: any[],
    segments: any[],
    setValue: Function,
    watch : Function
}

const PromoAddProductModal = ({
                                  open,
                                  handleClose,
                                  categories,
                                  segments, setValue, watch
                              }: AddProductModalProps) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'promo'});
    const {listProductByCategoryCodeList} = useProductCodeActions();
    const [selectedSegments, setSelectedSegments] = useState<any[]>([]);
    const [selectedCategories, setSelectedCategories] = useState<any[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<any>("");
    const [selectedProductDetail, setSelectedProductDetail] = useState<any>({
        name: "",
        productCode: "",
        statusCode: ""
    });
    const [products, setProducts] = useState<any[]>([]);
    const {getStatusLabelProduct} = useStatusValuesProduct();

    const getProducts= ()=>{
        setSelectedProduct("");
        if (selectedCategories.length > 0) {
            listProductByCategoryCodeList(selectedCategories).then(res => {
                setProducts(res);
            })
        }
    };

    useEffect(()=>{
        if(selectedProduct){
            let foundProd = products.find(p => p.productCode === selectedProduct)
            setSelectedProductDetail({
                name: foundProd.name,
                productCode: foundProd.productCode,
                statusCode: foundProd.statusCode
            })
        }
    },[selectedProduct]);

    useEffect(()=>{
        if(open){
           setSelectedSegments([]);
           setSelectedProduct("");
           setSelectedCategories([]);
           setSelectedProductDetail({
               name: "",
               productCode: "",
               statusCode: ""
           })
        }
    },[open])

    return (
        <Dialog disableEscapeKeyDown maxWidth={"lg"} fullWidth={true} open={open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Typography sx={{paddingLeft: "10px"}} fontWeight={"bold"} color={"primary"}>
                    {t('products.modalTitle')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        handleClose();
                    }}
                    color={"primary"}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRounded/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} alignItems={"center"}>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            id="selectedSegments"
                            select
                            SelectProps={{
                                MenuProps: MenuProps,
                                multiple: true,
                                renderValue: (selected: any) => selected.map((s: any) => segments.find(ss => ss.segmentCode === s)!.segmentName).join(', ')
                            }}
                            label={t('products.segment')}
                            value={selectedSegments}
                            onChange={(e)=>{
                                setSelectedSegments(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value);
                            }}
                        >
                            {segments.filter((s:any)=>{
                                if(watch('typology')=== PROMO_TYPOLOGY_SUBSCRIPTION)
                                    return s.segmentCode === "SUB"
                                if(watch('typology')=== PROMO_TYPOLOGY_CREDIT_CARD || watch('typology')=== PROMO_TYPOLOGY_SHORT_TERM)
                                    return s.segmentCode === 'RET';
                                return true
                            }).map((seg) => (
                                <MenuItem key={seg.segmentCode} value={seg.segmentCode}>
                                    <Checkbox checked={selectedSegments.indexOf(seg.segmentCode) > -1}/>
                                    <ListItemText primary={seg.segmentName}/>
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            id="selectedCategories"
                            select
                            SelectProps={{
                                MenuProps: MenuProps,
                                multiple: true,
                                renderValue: (selected: any) => selected.map((s: any) => categories.find(ss => ss.categoryCode === s)!.categoryName).join(', '),
                                onClose: ()=>{getProducts()}
                            }}
                            label={t('products.category')}
                            value={selectedCategories}
                            onChange={(e)=>{
                                setSelectedCategories(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value);
                            }}
                        >
                            {categories.filter((c:any)=>{
                                return selectedSegments.some((ss:any)=> ss === c.segmentCode);

                            }).map((cat) => (
                                <MenuItem key={cat.categoryCode} value={cat.categoryCode}>
                                    <Checkbox checked={selectedCategories.indexOf(cat.categoryCode) > -1}/>
                                    <ListItemText primary={cat.categoryName}/>
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={6}/>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            id={"selectedProduct"}
                            label={t('products.name')}
                            select
                            value={selectedProduct}
                            onChange={(e)=>{
                                setSelectedProduct(e.target.value);
                            }}
                            SelectProps={{MenuProps: MenuProps}}
                        >
                            {products?.filter((p:any)=>Array.isArray(watch('productCode')) ? watch('productCode').every((pp:any)=> pp!== p.productCode) :  false).map((a) => (
                                <MenuItem key={a.productCode} value={a.productCode}>
                                    {a.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            disabled
                            fullWidth
                            id="selectedProductCode"
                            label={t('products.code')}
                            value={selectedProductDetail.productCode}
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            disabled
                            fullWidth
                            id="selectedProductStatus"
                            label={t('products.status')}
                            value={getStatusLabelProduct(selectedProductDetail.statusCode)}
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{padding: "15px"}}>
                <Button variant={"outlined"} color={"accent"}
                        onClick={() => {
                            handleClose();
                        }}>
                    {t('buttons.cancel')}
                </Button>
                <Button color={"accent"} onClick={() => {
                    setValue('productCode', [...watch('productCode'),selectedProduct]);
                    handleClose();
                }}>
                    {t('buttons.add')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export default PromoAddProductModal;